// Seed news items shown on the member dashboard feed so the tab isn't
// empty on day 1. Real user-submitted news is merged from
// GET /api/news at runtime.
const SEED_NEWS = [
  {
    id: "seed-zenskar-series-a",
    title: "Zenskar raises US$15M Series A to expand agentic revenue automation",
    url: "https://www.businesswire.com/news/home/20260416872552/en/Zenskar-Raises-15-Million-Series-A",
    source: "BusinessWire",
    industry: "saas",
    blurb:
      "Bessemer-led round takes total funding to US$21.5M. Zenskar will push agentic capabilities across usage, billing and rev-rec.",
    created_at: "2026-04-16T00:00:00Z",
    seed: true,
  },
  {
    id: "seed-bluecopa-series-a",
    title: "Bluecopa closes US$7.5M Series A from Analog Partners and Blume",
    url: "https://economictimes.indiatimes.com/tech/funding/finops-startup-bluecopa-raises-7-5-million-from-analog-partners-blume-ventures-dallas-venture/articleshow/126486825.cms",
    source: "The Economic Times",
    industry: "saas",
    blurb:
      "Hyderabad-based finops platform serving Yatra, Porter and Purplle raises Series A led by Analog Partners and Blume Ventures.",
    created_at: "2026-01-10T00:00:00Z",
    seed: true,
  },
  {
    id: "seed-hyperbots-series-a",
    title: "Hyperbots raises US$6.5M Series A led by JSW Ventures",
    url: "https://entrackr.com/snippets/hyperbots-raises-65-mn-in-series-a-round-9062825",
    source: "Entrackr",
    industry: "saas",
    blurb:
      "Agentic AI co-pilots for finance and accounting; the round brings Arkam, Athera, Kalaari and JSW into the cap table.",
    created_at: "2025-09-06T00:00:00Z",
    seed: true,
  },
  {
    id: "seed-sebi-close",
    title: "SEBI shortens listed-company reporting timelines — CFOs feel the squeeze",
    url: "https://www.sebi.gov.in",
    source: "SEBI",
    industry: "education",
    blurb:
      "Listed groups like Veranda are turning to automated GL mapping and intercompany reconciliation to hit Day-0 close.",
    created_at: "2026-03-01T00:00:00Z",
    seed: true,
  },
  {
    id: "seed-perfios-bfsi",
    title: "Perfios crosses 1,000+ financial institutions across 18 countries",
    url: "https://perfios.ai",
    source: "Perfios",
    industry: "financial-services",
    blurb:
      "Serves State Bank of India, ICICI, Axis, HDFC and IDFC First with credit assessment, KYC and bank statement analytics.",
    created_at: "2026-02-15T00:00:00Z",
    seed: true,
  },
  {
    id: "seed-payzapp-celent",
    title: "Zeta + HDFC PayZapp wins Celent Model Bank 2024 Award",
    url: "https://www.zeta.tech/in/",
    source: "Celent",
    industry: "financial-services",
    blurb:
      "PayZapp rebuilt on Zeta Tachyon crossed 12M users and won 1 of 18 Model Bank 2024 awards from 140+ nominations across 36 countries.",
    created_at: "2024-11-05T00:00:00Z",
    seed: true,
  },
];

export default SEED_NEWS;
